'use strict'

module.exports = isObject

function isObject (input) {
  return Object.prototype.toString.apply(input) === '[object Object]'
}
